import { render } from "./DataGovernance.vue?vue&type=template&id=7c819fc1&scoped=true"
import script from "./DataGovernance.vue?vue&type=script&lang=js"
export * from "./DataGovernance.vue?vue&type=script&lang=js"

import "./DataGovernance.vue?vue&type=style&index=0&id=7c819fc1&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/HMS-MAIN/PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c819fc1"]])

export default __exports__